// La subida de nivel: reconocerla, y avisar una sola vez.
//
//     node scripts/prueba_subidaDeNivel.mjs      (desde frontend/)
//
// QUE PASABA, Y ERA J12. Gabri, 14 de octubre de 2026: *«cada vez que la Estrella sube de
// nivel —al hacer una leccion, abrir un cofre, hacer un test— debe aparecer una pantalla con
// la estrella brillando; a veces si aparece y a veces no»*. No era intermitente: habia
// ceremonia por UN camino de los cuatro. `components/SubidaDeNivel.jsx` estaba montado en un
// solo sitio, `pages/BossBattle.jsx`.
//
// Y EL DATO YA VIAJABA. `boss_service.add_xp` devuelve `{level_before, level_after,
// leveled_up, xp_gained, xp_next, xp_into_level, rango}`, y lo devuelven con el los cofres
// (`cofres/service.py`), el test, el pago del Mundo (`mundo/pago.py`) y las metas
// (`alpha/service.py`). O sea que el servidor lo decia desde hace meses y en la pantalla no
// pasaba nada: **lo que faltaba no era el dato, era alguien escuchando.**
//
// POR QUE SE RECONOCE POR LA FORMA Y NO POR EL NOMBRE. Cada respuesta lo llama a su manera
// —`nivel` en el Mundo y en los cofres, `level` en el Jefe—, y pedirle a cada pantalla que lo
// reenvie con el nombre bueno es la regla que se cumple acordandose, que es como se cumplio
// en uno de cuatro sitios. Aqui se busca la FORMA: un objeto con `level_before` y
// `level_after`. Asi lo encuentra tambien el quinto sitio, el que nadie ha escrito todavia.

/** Los dos campos por los que se reconoce una subida, vengan donde vengan. */
export const SENAS = ["level_before", "level_after"];

/** ¿Esto es un parte de nivel? */
export function esParteDeNivel(x) {
  return Boolean(x) && typeof x === "object"
    && SENAS.every((k) => typeof x[k] === "number");
}

/**
 * El parte de nivel que trae un cuerpo de respuesta, **solo si hubo subida**.
 *
 * Se mira el cuerpo entero y sus valores de primer nivel, que es donde lo ponen los cuatro
 * sitios; no se baja mas, porque un barrido profundo encuentra tambien lo que no es suyo
 * —el nivel de OTRO alumno en una tabla de la Liga, por ejemplo— y entonces la ceremonia le
 * saltaria a quien mira la clasificacion.
 *
 * Y SE EXIGE QUE HAYA SUBIDO DE VERDAD. `leveled_up` lo dice el servidor; si faltara, se
 * compara. Sin eso, cada respuesta que lleva el saldo celebraria no haber cambiado.
 */
export function laSubida(cuerpo) {
  if (!cuerpo || typeof cuerpo !== "object") return null;
  const candidatos = [cuerpo, ...Object.values(cuerpo)];
  for (const c of candidatos) {
    if (!esParteDeNivel(c)) continue;
    const subio = typeof c.leveled_up === "boolean"
      ? c.leveled_up
      : c.level_after > c.level_before;
    if (subio) return c;
  }
  return null;
}

// ─────────────────────────────────────────────────────────── el aviso, y quien lo escucha
//
// UNA LISTA DE OYENTES Y NADA MAS. No es un estado global: no guarda la ultima subida, asi
// que nadie puede montarse despues y encontrarse una ceremonia vieja esperandole. Lo que no
// se escucho no paso.

const oyentes = new Set();

/** Escucha las subidas. Devuelve la funcion que deja de escuchar. */
export function escucha(fn) {
  oyentes.add(fn);
  return () => oyentes.delete(fn);
}

/**
 * CALLAR A PROPOSITO, y hace falta por un sitio: la pantalla del Jefe ya celebra la subida
 * con su propia tarjeta dentro del resultado del combate. Sin esto, al ganarle a un Jefe
 * saldrian las dos, una encima de otra.
 *
 * Es un contador y no un booleano porque dos pantallas pueden callar a la vez y la primera
 * en terminar no tiene que devolverle la voz a la otra.
 */
let callados = 0;
export function silencia() { callados += 1; return () => { callados = Math.max(0, callados - 1); }; }
export const hayQueCallar = () => callados > 0;

/** Avisa de una subida. No hace nada si alguien ha pedido silencio. */
export function anuncia(nivel) {
  if (!nivel || hayQueCallar()) return false;
  for (const fn of oyentes) fn(nivel);
  return true;
}

/** Para las pruebas: deja el modulo como recien cargado. */
export function olvida() { oyentes.clear(); callados = 0; }
